import React from 'react';
import PropTypes from 'prop-types';

import InvitationsForm from 'components/auth/InvitationsForm';
import Footer from 'pages/Login/footer';
import { OnTruckLogo } from 'refactored/ui/icons';

const Invitations = ({ className, t, match }) => (
  <div className={`${className} public-page`}>
    <section className="main" role="main">
      <OnTruckLogo />
      <InvitationsForm match={match} />
    </section>
    <Footer t={t} />
  </div>
);

Invitations.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
};

Invitations.defaultProps = {
  className: '',
  t: (t) => t,
  match: {},
};

export default Invitations;
